import Vue from 'vue';
import Router from 'vue-router';
import moment from 'moment';
import store from './store';

// Not perfect but easier to find components when they are close to alphabetical order
const attributesManagement = () => import('@/components/attributes/AttributesManagement.vue');
const BoardComponents = () => import('@/components/systemadmin/boardcomponents/BoardComponents.vue');
const CompleteTask = () => import('@/components/taskManagement/completetask/CompleteTask.vue');
const Dashboard = () => import('@/components/dashboard/Dashboard.vue');
const Device = () => import('@/components/zoneDevices/Device.vue');
const DestroyedPlants = () => import('@/components/plantDestruction/DestroyedPlants.vue');
const ExecutiveManager = () => import('@/components/dashboard/ExecutiveManager.vue');
const AdminManager = () => import('@/components/dashboard/AdminManager.vue');
const AutogrowDashboard = () => import('@/components/autogrow/Autogrow.vue');
const FacilityEditor = () => import('@/components/systemadmin/facilities/Facilities.vue');
const FacilityManager = () => import('@/components/dashboard/FacilityManager.vue');
const FarmManager = () => import('@/components/dashboard/FarmManager.vue');
const Service = () => import('@/components/dashboard/Service.vue');
const FullAreaView = () => import('@/components/fullAreaView/FullAreaView.vue');
const ColorPalettes = () => import('@/components/systemadmin/colors/ColorPalettes.vue');
const Growplans = () => import('@/components/growplans/Growplans.vue');
const Growplan = () => import('@/components/growplan/Growplan.vue');
const GrowTypeTasksEditor = () => import('@/components/systemadmin/growTaskTypes/GrowTaskTypes.vue');
const Hardware = () => import('@/components/hardware/Hardware.vue');
const HelpTopicsEditor = () => import('@/components/systemadmin/helpTopics/HelpTopics.vue');
const HistoricalLifecycles = () => import('@/components/historicalLifecycles/HistoricalLifecycles.vue');
const LicensesEditor = () => import('@/components/systemadmin/licenses/Licenses.vue');
const Lifecycles = () => import('@/components/lifecycles/Lifecycles.vue');
const Login = () => import('@/components/login/Login.vue');
const Mums = () => import('@/components/mums/Mums.vue');
const PasswordReset = () => import('@/components/accountManagement/PasswordReset.vue');
const ProductionPlanning = () => import('@/components/productionPlanning/ProductionPlanning.vue');
const PlatformAllocations = () => import('@/components/productionPlanning/PlatformAllocations.vue');
const PlatformGroups = () => import('@/components/platformGroups/PlatformGroups.vue');
// const ProductionSchedule = () => import('./components/productionSchedule/ProductionSchedule.vue');
const Profile = () => import('./components/profile/Profile.vue');
const SetAccount = () => import('./components/accountManagement/SetAccount.vue');
const StartLifeCycle = () => import('./components/taskManagement/startLifecycle/StartLifecycle.vue');
const TrainingResources = () => import('./components/trainingResources/TrainingResources.vue');
const TeamManagement = () => import('./components/teamManagement/TeamManagement.vue');
const TaskflowMain = () => import('./components/taskflow/Taskflow.vue');
// const TestProperties = () => import ('./components/systemadmin/tests/TestProperties.vue')
//const TrainingPdf = () => import('./components/pdfs/TrainingPdfs.vue')
const VpdProfileEditor = () => import('@/components/systemadmin/vpdProfiles/VpdProfiles.vue');
const ZoneDevicesControl = () => import('./components/zoneDevices/ZoneDevices.vue');
const ZoneDevicesGX8Control = () => import('./components/zoneDevices/ZoneDevicesGX8.vue');
const EnterpriseDefault = () => import('./components/zoneDevices/enterpriseDashboard/EnterpriseDefault.vue');
const EnterpriseDashboardControl = () => import('./components/zoneDevices/enterpriseDashboard/EnterpriseDashboard.vue');
const EnterpriseDashboardFacilityControl = () =>
  import('./components/zoneDevices/enterpriseDashboard/FacilityDashboard.vue');
const MaintenanceTasks = () => import('./components/maintenanceTasks/MaintenanceTasks.vue');
const MaintenanceUsers = () => import('./components/maintenanceTasks/userManagement/MaintenanceUsers.vue');
const RepairTickets = () => import('./components/repairTickets/RepairTickets.vue');
const MenuManager = () => import('./components/systemadmin/MenuManager/MenuManager.vue');
const SystemTablesEditor = () => import('./components/systemadmin/systemtables/SystemTables.vue');
const CalendarEventTypesEditor = () =>
  import('./components/systemadmin/calendarEventTypes/CalendarEventTypesEditor.vue');
const Consumables = () => import('./components/consumables/consumable/Consumables.vue');
const ConsumableTypes = () => import('./components/consumables/consumable/ConsumableTypes.vue');
const Zones = () => import('./components/systemadmin/zones/Zones.vue');
const ZoneTypes = () => import('./components/systemadmin/zonesTypes/ZonesTypes.vue');
const HarvestWorkflows = () => import('./components/systemadmin/harvestWorkflows/HarvestWorkflows.vue');
const WorkflowFacilityTaskTypes = () => import('./components/systemadmin/harvestWorkflows/WorkflowTaskTypes.vue');
const VirtualDeviceTypes = () => import('./components/systemadmin/virtualDeviceTypes/VirtualDeviceTypes.vue');
const ExceptionTypes = () => import('./components/systemadmin/exceptionTypes/ExceptionTypes.vue');
const ExceptionNotifiedUsers = () => import('./components/systemadmin/exceptionTypes/ExceptionNotifiedUsers.vue');
const UserExceptionLogs = () => import('./components/systemadmin/exceptionTypes/UserExceptionLogs.vue');
const Inventory = () => import('./components/systemadmin/inventory/Inventory.vue');
const InventoryHistory = () => import('./components/systemadmin/inventory/InventoryHistory.vue');
const HardwareTicketStatuses = () =>
  import('./components/systemadmin/hardwareTicketStatuses/HardwareTicketStatuses.vue');
const RepeatingTasks = () => import('./components/taskManagement/repeatingTasks/RepeatingTasks.vue');
const StrainsManagement = () => import('./components/strains/StrainsManagement.vue');
const FacilityStrains = () => import('./components/strains/FacilityStrains.vue');
const GrowphaseTemplates = () => import('./components/systemadmin/growphasetemplates/GrowPhaseTemplates.vue');
const PortExpanderErrorLogs = () => import('./components/systemadmin/portexpandererrorlog/PortExpanderErrorLog.vue');
const LifecycleFixes = () => import('./components/systemadmin/lifecyclefixes/LifecycleFixes.vue');
const Laboratories = () => import('./components/laboratories/Laboratories.vue');
const ZoneConfig = () => import('./components/zones/Zones.vue');
const RacklessDevice = () => import('./components/zones/Device.vue');
const SafetySheetsViewer = () => import('./components/trainingResources/SafetySheetsViewer.vue');
const TestBatch = () => import('./components/testBatch/TestBatch.vue');
const TestTypes = () => import('./components/systemadmin/tests/Tests.vue');
const GrowPlanCategories = () => import('./components/systemadmin/growplancategories/GrowPlanCategories.vue');
const FacilityConsumables = () => import('./components/consumables/Consumables.vue');
const DryWeights = () => import('./components/dryweights/DryWeights.vue');
const MalfunctioningGrowUnits = () => import('./components/servicetickets/ServiceTickets.vue');
const IpmApplicationReports = () => import('./components/ipmApplicationReports/ipmApplicationReports.vue');
const UnitsOfMeasure = () => import('./components/systemadmin/unitsOfMeasure/UnitsOfMeasure.vue');
const ConsumableCalculationTypes = () => import('./components/consumables/ConsumableCalculationTypes.vue');
const ConsumablesLedger = () => import('./components/consumables/ledger/Ledger.vue');
const OpExCalculator = () => import('./components/opexcalculator/OpExCalculator.vue');
const IrrigationDashboard = () => import('./components/systemadmin/irrigationdashboard/IrrigationDashboard.vue');
const Apps = () => import('./components/systemadmin/apps/Apps.vue');
const ServiceLevels = () => import('./components/systemadmin/serviceLevels/ServiceLevels.vue');
const ServiceLevelAgreements = () =>
  import('./components/systemadmin/servicelevelAgreements/ServiceLevelAgreements.vue');
const NutrientDeficiencyDiagnosis = () =>
  import('./components/systemadmin/nutrientdeficiencydiagnosis/NutrientDeficiencyDiagnosis.vue');
const SubtenantStatus = () => import('@/components/dashboard/Subtenant.vue');
const PlantContainerTypes = () => import('@/components/systemadmin/plantcontainertypes/PlantContainerTypes.vue');
const ReleaseNotes = () => import('./components/systemadmin/releaseNotes/ReleaseNotes.vue');
const HardwareTicketProblemTypes = () =>
  import('./components/systemadmin/hardwareTicketProblemType/HardwareTicketProblemTypes.vue');
const SOPs = () => import('./components/systemadmin/sops/SOPs.vue');
const StateCompliance = () => import('./components/metrc/Metrc.vue');
const BoardConfigurationWizard = () =>
  import('./components/systemadmin/boardconfigurationwizard/BoardConfigurationWizard.vue');
const ProvisionalControllers = () => import('./components/systemadmin/provisionalControllers/ProvisionalControllers');
const ControlBoard = () => import('./components/systemadmin/controlboard/ControlBoard.vue');
const Clients = () => import('./components/systemadmin/clients/Clients.vue');
const GrowStages = () => import('./components/systemadmin/growstages/GrowStages.vue');
const RedAlerts = () => import('./components/systemadmin/redalerts/RedAlerts.vue');
const FacilityAlerts = () => import('./components/alerts/FacilityAlerts.vue');
const MetrcLocations = () => import('./components/metrc/locations/Locations.vue');
const MetrcItems = () => import('./components/metrc/items/Items.vue');
const MetrcOutbox = () => import('./components/metrc/messagequeue/MessageQueue.vue');
const MetrcPlantBatches = () => import('./components/metrc/plantbatches/PlantBatches.vue');
const MetrcPackages = () => import('./components/metrc/packages/Packages.vue');
const MetrcPlants = () => import('./components/metrc/plants/Plants.vue');
const MetrcHarvests = () => import('./components/metrc/harvests/Harvests.vue');
const WarrantyTermsEditor = () => import('@/components/systemadmin/warrantyTerms/WarrantyTerms.vue');
const MetrcCacheStatus = () => import('./components/metrc/CacheStatus.vue');
const MetrcStrains = () => import('./components/metrc/strains/Strains.vue');
const MetrcLabTests = () => import('./components/metrc/labtests/LabTests.vue');
const MetrcTestingLabs = () => import('./components/metrc/testingLabs/TestingLabs.vue');
const Fsa = () => import('./components/systemadmin/fsa/Fsa.vue');
const PostHarvestCharts = () => import('./components/postharvest/charts/Charts.vue');
const MetrcSales = () => import('./components/metrc/sales/Sales.vue');
const EcuTestPlans = () => import('./components/systemadmin/ecutestplan/EcuTestPlan.vue');
const MetrcTransfers = () => import('./components/metrc/transfers/Transfers.vue');
const FacilityMaps = () => import('./components/floorplans/Floorplans.vue');
const FacilityMapsDisplay = () => import('./components/floorplans/Display.vue');
const ProductInventory = () => import('./components/postharvest/productinventory/ProductInventory.vue');
const PlantIntake = () => import('./components/facilityIntake/plants/PlantIntake.vue');
const InventoryIntake = () => import('./components/facilityIntake/inventory/InventoryIntake.vue');
const Diagnostics = () => import('./components/systemadmin/diagnostics/Diagnostics.vue');
const Controllers = () => import('./components/systemadmin/infrastructure/controller/Controller.vue');
const FacilityInfrastructure = () => import('./components/systemadmin/infrastructure/FacilityInfrastructure.vue');
const GoodNewsPresentation = () => import('./components/presentation/goodnews/GoodNews.vue');
// const DeviceConfigTemplates = () => import('./components/systemadmin/deviceconfigurationtemplates/DeviceConfigurationTemplates.vue');
const LightSpectrumDefinitions = () =>
  import('./components/systemadmin/lightspectrumdefinitions/LightSpectrumDefinitions.vue');
const CameraTypes = () => import('./components/systemadmin/cameratypes/CameraTypes.vue');
const ActiveUnitsReport = () => import('./components/systemadmin/activeUnitsReport/ActiveUnitsReport.vue');
const ProductionSuccessReport = () =>
  import('./components/systemadmin/productionSuccessReport/ProductionSuccessReport.vue');
const HarvestHistoryReport = () => import('./components/systemadmin/productionSuccessReport/HarvestHistoryReport.vue');
const PackagesReport = () => import('./components/systemadmin/productionSuccessReport/PackagesReport.vue');
const InvoiceReport = () => import('./components/systemadmin/productionSuccessReport/InvoiceReport.vue');
const DataArchiveTool = () => import('./components/systemadmin/dataArchiveTool/DataArchiveTool.vue');
const FacilityEquipment = () => import('./components/extraction/facilityEquipment/FacilityEquipment.vue');
const ExtractionEquipment = () => import('./components/extraction/equipment/Equipment.vue');
const ExtractionRecipes = () => import('./components/extraction/recipes/Recipes.vue');
const PostHarvestBatches = () => import('./components/postharvest/batches/Batches.vue');

const ExtractionWorkflows = () => import('./components/extraction/workflow/Workflow.vue');
const SurveillanceCameras = () => import('./components/surveillancecameras/SurveillanceCameras.vue');
const FacilityForms = () => import('./components/systemadmin/formBuilder/FacilityForms.vue');
const FormSubmissions = () => import('./components/systemadmin/formBuilder/FormSubmissions.vue');
const FormSubmissionSearch = () => import('./components/systemadmin/formBuilder/FormSubmissionSearch.vue');

const Harvests = () => import('./components/postharvest/harvests/Harvests.vue');

const ExtractionEquipmentDashboard = () => import('./components/extraction/dashboard/Dashboard.vue');

const ExtractionVdt = () => import('./components/extraction/devicetypes/DeviceTypes.vue');

const WashingtonStateCompliance = () => import('./components/statecompliance/washington/WashingtonStateCompliance.vue');
const WashingtonStateComplianceExports = () => import('./components/statecompliance/washington/ExportTable.vue');
const PLCs = () => import('./components/PLCs/PLCs.vue');
const Sensors = () => import('./components/sensors/Sensors.vue');

const SoftwareKanBanView = () => import('./components/ticketingSystem/SoftwareKanBanView.vue');
const HardwareKanBanView = () => import('./components/ticketingSystem/HardwareKanBanView.vue');

const NotificationsUnsubscribe = () => import('./components/notifications/Unsubscribe.vue');
const NotificationsResolve = () => import('./components/notifications/Resolve.vue');
const ActivityLogs = () => import('./components/activityLogs/ActivityLogs.vue');

// Status Pages
const Page401 = () => import('@/components/staticPages/Page401.vue');
const Page404 = () => import('@/components/staticPages/Page404.vue');

Vue.use(Router);

function logoutUser(to, from, next) {
  window.localStorage.setItem('isAuthenticated', false);
  window.localStorage.setItem('user', null);
  next({
    path: '/login',
  });
}

function requiresAuth(to, from, next) {
  const mustCheckAuth = to.matched.some(({ meta }) => meta.requiresAuth);
  if (mustCheckAuth) {
    const isAuth = window.localStorage.getItem('isAuthenticated');
    const user = JSON.parse(window.localStorage.getItem('user')) || {};
    // const oneDayAgo = moment().subtract(1, 'day');
    const lastlogin = moment(user.lastlogin);
    if (isAuth != null && isAuth === 'true' && user.lastlogin) {
      next();
    } else {
      window.localStorage.setItem('isAuthenticated', false);
      window.localStorage.setItem('user', null);
      next({
        path: '/login',
        query: {
          redirect: to.fullPath,
        },
      });
    }
  } else {
    next();
  }
}

function checkMenuPermissions(to, from, next) {
  const mustCheckMenuPermissions = to.matched.some(({ meta }) => meta.mustCheckMenuPermissions);
  const menuItem = to.meta.menuItem;
  if (!mustCheckMenuPermissions) {
    next();
  } else {
    const user = JSON.parse(window.localStorage.getItem('user')) || {};
    if (typeof user.menus === 'undefined') {
      store
        .dispatch('getMenuForCurrentUser', {
          apitoken: user.apitoken,
          facility_id: user.facility_id,
        })
        .then(() => {
          checkMenuPermissions(to, from, next);
        });
    } else {
      const allowedMenu = user.menus.find((eachMenu) => {
        return (
          eachMenu.route === to.path ||
          eachMenu.children.find((eachChildMenu) => {
            return eachChildMenu.route === to.path;
          }) ||
          (menuItem &&
            eachMenu.children.find((eachChildMenu) => {
              return eachChildMenu.menuItem === menuItem;
            }))
        );
      });
      if (allowedMenu || to.path === '/') {
        next();
      } else {
        next({ name: 'page-401' });
      }
    }
  }
}

function setRouteHelpTopic(to, from, next) {
  store.dispatch('setTempHelpTopicKey', null);
  store.dispatch('setComponentHelpTopicKey', null);
  const helpTopicKey = to.meta.helpTopicKey;
  if (!helpTopicKey) {
    store.dispatch('setRouteHelpTopicKey', null);
    next();
  } else {
    store.dispatch('setRouteHelpTopicKey', helpTopicKey);
    next();
  }
}

const router = new Router({
  //mode: 'history',
  routes: [
    {
      name: 'login',
      path: '/login',
      component: Login,
      beforeEnter: function (to, from, next) {
        const isAuth = window.localStorage.getItem('isAuthenticated');

        if (isAuth != null && isAuth === 'true') {
          if (this && this.$router) return this.$router.replace('/dashboard');
        }

        return next();
      },
    },
    {
      name: 'notifications-unsubscribe',
      path: '/notifications/unsubscribe/:messageId',
      component: NotificationsUnsubscribe,
    },
    {
      name: 'notifications-resolve',
      path: '/notifications/resolve/:messageId',
      component: NotificationsResolve,
    },
    {
      name: 'profile',
      path: '/profile',
      component: Profile,
      params: {
        custom: 'custom',
      },
      meta: {
        requiresAuth: true,
        mustCheckMenuPermissions: false,
        helpTopicKey: 'adjusting-profile',
      },
    },
    {
      name: 'color-palettes',
      path: '/admin/colors',
      component: ColorPalettes,
      meta: {
        requiresAuth: true,
        mustCheckMenuPermissions: true,
      },
    },

    {
      name: 'team-management',
      path: '/teammanagement',
      component: TeamManagement,
      meta: {
        requiresAuth: true,
        mustCheckMenuPermissions: true,
        helpTopicKey: 'administration-team-management',
      },
    },
    {
      name: 'training-pdfs',
      path: '/education',
      component: TrainingResources,
      meta: {
        requiresAuth: true,
        mustCheckMenuPermissions: true,
        helpTopicKey: 'training-and-sops-documentation',
      },
    },
    {
      name: 'research-pdfs',
      path: '/research',
      component: TrainingResources,
      meta: {
        requiresAuth: true,
        mustCheckMenuPermissions: true,
        helpTopicKey: 'research-documentation',
      },
    },
    {
      name: 'safety-sheets-viewer',
      path: '/safety',
      component: SafetySheetsViewer,
      meta: {
        requiresAuth: true,
        mustCheckMenuPermissions: true,
        helpTopicKey: 'training-and-sops-sds',
      },
    },
    {
      name: 'mums',
      path: '/mums',
      component: Mums,
      meta: {
        requiresAuth: true,
        mustCheckMenuPermissions: true,
      },
    },
    {
      name: 'apps',
      path: '/admin/apps',
      component: Apps,
      meta: {
        requiresAuth: true,
        mustCheckMenuPermissions: true,
      },
    },
    {
      name: 'strains',
      path: '/strains',
      component: StrainsManagement,
      meta: {
        requiresAuth: true,
        mustCheckMenuPermissions: true,
        helpTopicKey: 'cultivation-strains',
      },
    },
    {
      name: 'facility-strains',
      path: '/facility-strains',
      component: FacilityStrains,
      meta: {
        requiresAuth: true,
        mustCheckMenuPermissions: true,
        helpTopicKey: 'cultivation-facility-strains',
      },
    },
    {
      name: 'varietals',
      path: '/varietals',
      component: StrainsManagement,
      meta: {
        requiresAuth: true,
        mustCheckMenuPermissions: true,
      },
    },
    {
      name: 'genetics-historical',
      path: '/genetics-historical/:growplan_id?',
      component: HistoricalLifecycles,
      props: true,
      meta: {
        requiresAuth: true,
        mustCheckMenuPermissions: true,
      },
    },

    {
      name: 'comparelifecycles',
      path: '/comparelifecycles',
      component: HistoricalLifecycles,
      props: true,
      meta: {
        requiresAuth: true,
        mustCheckMenuPermissions: true,
        helpTopicKey: 'post-harvest-compare-lifecycle-outcomes',
      },
    },

    {
      name: 'irrigation-dashboard',
      path: '/systemadmin/irrigationdashboard',
      component: IrrigationDashboard,
      meta: {
        requiresAuth: true,
        mustCheckMenuPermissions: true,
      },
    },
    {
      name: 'attributes',
      path: '/attributes',
      component: attributesManagement,
      meta: {
        requiresAuth: true,
        mustCheckMenuPermissions: true,
      },
    },
    /*
    {
      name: 'production-schedule',
      path: '/production-schedule',
      component: ProductionSchedule,
      beforeEnter: requireAuth,
      meta: {
        mustCheckMenuPermissions: true
      }
    },
    */

    {
      name: 'licenses',
      path: '/admin/licenses',
      component: LicensesEditor,
      meta: {
        requiresAuth: true,
        mustCheckMenuPermissions: true,
        helpTopicKey: 'administration-facility-licenses',
      },
    },
    {
      name: 'help-topics',
      path: '/admin/help-topics',
      component: HelpTopicsEditor,
      meta: {
        requiresAuth: true,
        mustCheckMenuPermissions: true,
      },
    },
    {
      name: 'warranty-terms',
      path: '/admin/warranty-terms',
      component: WarrantyTermsEditor,
      meta: {
        requiresAuth: true,
        mustCheckMenuPermissions: true,
      },
    },
    {
      name: 'vpd-profiles',
      path: '/admin/vpd-profiles',
      component: VpdProfileEditor,
      meta: {
        requiresAuth: true,
        mustCheckMenuPermissions: true,
      },
    },
    {
      name: 'grow-task-types',
      path: '/admin/grow-task-types',
      component: GrowTypeTasksEditor,
      meta: {
        requiresAuth: true,
        mustCheckMenuPermissions: false, //TODO: Add permissions for this
      },
    },
    {
      name: 'lifecycles',
      path: '/lifecycles',
      component: Lifecycles,
      meta: {
        requiresAuth: true,
        mustCheckMenuPermissions: true,
        helpTopicKey: 'cultivation-lifecycles-overview',
      },
    },
    {
      name: 'lifecycles-types',
      path: '/lifecycles/:type',
      component: Lifecycles,
      meta: {
        requiresAuth: true,
        // mustCheckMenuPermissions: true,
        helpTopicKey: 'cultivation-lifecycles-overview',
      },
    },

    {
      name: 'lifecycles-growplan',
      path: '/lifecycles/:growplanId',
      component: Lifecycles,
      meta: {
        requiresAuth: true,
        mustCheckMenuPermissions: true,
      },
    },
    {
      name: 'growplans',
      path: '/growplans',
      component: Growplans,
      meta: {
        requiresAuth: true,
        mustCheckMenuPermissions: true,
        helpTopicKey: 'cultivation-grow-plans-overview',
      },
    },
    {
      name: 'destroyed-plants',
      path: '/destroyed-plants',
      component: DestroyedPlants,
      meta: {
        requiresAuth: true,
        mustCheckMenuPermissions: true,
      },
    },
    {
      name: 'production-planning',
      path: '/productionplanning',
      component: ProductionPlanning,
      meta: {
        requiresAuth: true,
        mustCheckMenuPermissions: true,
        helpTopicKey: 'production-planning-calculator-overview',
      },
    },
    {
      name: 'platform-allocations',
      path: '/platform-allocations',
      component: PlatformAllocations,
      meta: {
        requiresAuth: true,
        mustCheckMenuPermissions: true,
      },
    },
    {
      name: 'platform-groups',
      path: '/platform-groups',
      component: PlatformGroups,
      meta: {
        requiresAuth: true,
        mustCheckMenuPermissions: true,
      },
    },
    {
      name: 'full-area-view',
      path: '/full-area-view',
      component: FullAreaView,
      meta: {
        requiresAuth: true,
        mustCheckMenuPermissions: true,
      },
    },
    {
      name: 'taskflow-main',
      path: '/taskflowmain',
      component: TaskflowMain,
      meta: {
        requiresAuth: true,
        mustCheckMenuPermissions: true,
        helpTopicKey: 'dashboards-your-tasks-overview',
      },
    },
    /*
    {
      name: 'test-properties',
      path: '/admin/test-properties',
      component: TestProperties,
      beforeEnter: requireAuth,
      meta: {
        mustCheckMenuPermissions: true
      }
    },
    */

    {
      name: 'create-growplan',
      path: '/growplans/creategrowplan',
      component: Growplan,
      meta: {
        requiresAuth: true,
        mustCheckMenuPermissions: true,
        menuItem: 'Grow Plans',
      },
    },
    {
      name: 'growplan',
      path: '/growplan/:id',
      component: Growplan,
      props: true,
      meta: {
        requiresAuth: true,
        mustCheckMenuPermissions: true,
        menuItem: 'Grow Plans',
        helpTopicKey: 'cultivation-grow-plans-properties',
      },
    },
    {
      name: 'view-growplan',
      path: '/view/growplan/:id',
      component: Growplan,
      props: true,
      meta: {
        requiresAuth: true,
        mustCheckMenuPermissions: true,
        menuItem: 'Grow Plans',
      },
    },
    {
      name: 'set-account',
      path: '/setaccount',
      component: SetAccount,
    },
    {
      name: 'start-lifecycle',
      path: '/growplans/startlifecycle/:growplanId',
      component: StartLifeCycle,
      meta: {
        requiresAuth: true,
        mustCheckMenuPermissions: true,
        menuItem: 'Grow Plans',
      },
    },
    {
      name: 'growplan-task',
      path: '/growplantask/:growplanId/:lifecycleId/:lifecycleTaskId/:growTaskId',
      component: CompleteTask,
      meta: {
        requiresAuth: true,
        mustCheckMenuPermissions: false,
      },
    },
    {
      name: 'growplancategories',
      path: '/growplancategories',
      component: GrowPlanCategories,
      meta: {
        requiresAuth: true,
        mustCheckMenuPermissions: true,
      },
    },
    {
      name: 'operational-task',
      path: '/lifecycles/operationaltask/:growplanId/:lifecycleId/:taskTypeId?',
      component: CompleteTask,
      meta: {
        requiresAuth: true,
        mustCheckMenuPermissions: true,
        menuItem: 'Lifecycles',
        helpTopicKey: 'cultivation-lifecycles-operational-tasks-overview',
      },
    },
    {
      name: 'logout',
      path: '/logout',
      beforeEnter: logoutUser,
    },
    {
      name: 'page-404',
      path: '/notfound',
      component: Page404,
    },
    {
      name: 'page-401',
      path: '/unauthorized',
      component: Page401,
    },
    {
      name: 'password-reset',
      path: '/passwordreset',
      component: PasswordReset,
    },

    {
      name: 'zone-devices-gx8',
      path: '/gx8',
      component: ZoneDevicesGX8Control,
      meta: {
        requiresAuth: true,
        mustCheckMenuPermissions: false,
        helpTopicKey: 'dashboards-vfu-igr-dashboard',
      },
    },

    {
      name: 'enterprise-dashboard',
      path: '/enterprise-dashboard',
      component: EnterpriseDashboardControl,
      meta: {
        requiresAuth: true,
        mustCheckMenuPermissions: false,
      },
    },

    {
      name: 'default-dashboard',
      path: '/default-dashboard',
      component: EnterpriseDefault,
      meta: {
        requiresAuth: true,
        mustCheckMenuPermissions: false,
      },
    },

    {
      name: 'enterprise-dashboard-facility',
      path: '/enterprise-dashboard/facilities/:facilityId',
      component: EnterpriseDashboardFacilityControl,
      meta: {
        requiresAuth: true,
        mustCheckMenuPermissions: false,
      },
    },

    {
      name: 'zone-devices',
      path: '/zone-devices/:mode',
      component: ZoneDevicesControl,
      meta: {
        requiresAuth: true,
        mustCheckMenuPermissions: false,
        helpTopicKey: 'dashboards-vfu-igr-dashboard',
      },
    },

    {
      name: 'autogrow-dashboard',
      path: '/dashboard/autogrow',
      component: AutogrowDashboard,
      meta: {
        requiresAuth: true,
        mustCheckMenuPermissions: true,
      },
    },
    {
      name: 'menu-manager',
      path: '/admin/menu-manager',
      component: MenuManager,
      meta: {
        requiresAuth: true,
        mustCheckMenuPermissions: true,
      },
    },
    {
      name: 'boardcomponents',
      path: '/admin/board-components',
      component: BoardComponents,
      meta: {
        requiresAuth: true,
        mustCheckMenuPermissions: true,
      },
    },
    {
      name: 'dashboard',
      path: '/dashboard',
      component: Dashboard,
      meta: {
        requiresAuth: true,
        mustCheckMenuPermissions: false,
        helpTopicKey: 'dashboards-overview',
      },
    },
    {
      name: 'farm-manager',
      path: '/dashboard/farm',
      component: FarmManager,
      meta: {
        requiresAuth: true,
        mustCheckMenuPermissions: true,
        helpTopicKey: 'dashboards-farm-manager-overview',
      },
    },
    {
      name: 'service-dashboard',
      path: '/dashboard/servicedashboard',
      component: Service,
      meta: {
        requiresAuth: true,
        mustCheckMenuPermissions: true,
      },
    },
    {
      name: 'executive-manager',
      path: '/dashboard/executive',
      component: ExecutiveManager,
      meta: {
        requiresAuth: true,
        mustCheckMenuPermissions: true,
        helpTopicKey: 'dashboards-facility-overview',
      },
    },
    {
      name: 'facilities',
      path: '/admin/facilities',
      component: FacilityEditor,
      meta: {
        requiresAuth: true,
        mustCheckMenuPermissions: true,
        helpTopicKey: 'administration-facility-management',
      },
    },
    {
      name: 'facility-manager',
      path: '/dashboard/facility',
      component: FacilityManager,
      meta: {
        requiresAuth: true,
        mustCheckMenuPermissions: true,
        helpTopicKey: 'dashboards-facility-manager-overview',
      },
    },
    {
      name: 'admin-manager',
      path: '/dashboard/admin',
      component: AdminManager,
      meta: {
        requiresAuth: true,
        mustCheckMenuPermissions: true,
        helpTopicKey: 'dashboards-overview',
      },
    },
    {
      name: 'maintenance-tasks',
      path: '/dashboard/maintenance-tasks',
      component: MaintenanceTasks,
      meta: {
        requiresAuth: true,
        mustCheckMenuPermissions: true,
      },
    },
    {
      name: 'maintenance-users',
      path: '/dashboard/maintenance-users',
      component: MaintenanceUsers,
      meta: {
        requiresAuth: true,
        mustCheckMenuPermissions: true,
      },
    },
    {
      name: 'repair-tickets',
      path: '/dashboard/repair-tickets',
      component: RepairTickets,
      meta: {
        requiresAuth: true,
        mustCheckMenuPermissions: true,
      },
    },
    {
      name: 'hardware',
      path: '/hardware',
      component: Hardware,
      meta: {
        requiresAuth: true,
        mustCheckMenuPermissions: true,
      },
    },
    {
      name: 'system-tables',
      path: '/admin/systemtables',
      component: SystemTablesEditor,
      meta: {
        requiresAuth: true,
        mustCheckMenuPermissions: true,
      },
    },
    {
      name: 'calendar-event-types-editor',
      path: '/admin/calendar-event-types',
      component: CalendarEventTypesEditor,
      meta: {
        requiresAuth: true,
        mustCheckMenuPermissions: true,
      },
    },
    {
      name: 'consumables',
      path: '/admin/consumables',
      component: Consumables,
      meta: {
        requiresAuth: true,
        mustCheckMenuPermissions: true,
        helpTopicKey: 'consumables-configuring-consumable-items',
      },
    },
    {
      name: 'consumableTypes',
      path: '/admin/consumable-types',
      component: ConsumableTypes,
      meta: {
        requiresAuth: true,
        mustCheckMenuPermissions: true,
      },
    },
    {
      name: 'zones',
      path: '/admin/zones',
      component: Zones,
      meta: {
        requiresAuth: true,
        mustCheckMenuPermissions: true,
      },
    },
    {
      name: 'zone-types',
      path: '/admin/zone-types',
      component: ZoneTypes,
      meta: {
        requiresAuth: true,
        mustCheckMenuPermissions: true,
      },
    },
    {
      name: 'facility-forms',
      path: '/admin/facility-forms',
      component: FacilityForms,
      meta: {
        requiresAuth: true,
        mustCheckMenuPermissions: true,
      },
    },
    {
      name: 'form-submissions',
      path: '/admin/form-submissions',
      component: FormSubmissions,
      meta: {
        requiresAuth: true,
        mustCheckMenuPermissions: true,
      },
    },
    {
      name: 'form-submission-search',
      path: '/admin/form-submission-search',
      component: FormSubmissionSearch,
      meta: {
        requiresAuth: true,
        mustCheckMenuPermissions: true,
      },
    },
    {
      name: 'harvest-workflows',
      path: '/admin/harvest-workflows',
      component: HarvestWorkflows,
      meta: {
        requiresAuth: true,
        mustCheckMenuPermissions: true,
        helpTopicKey: 'post-harvest-workflows-defining-a-workflow-template',
      },
    },
    {
      name: 'workflow-facility-task-types',
      path: '/admin/workflow-facility-task-types',
      component: WorkflowFacilityTaskTypes,
      meta: {
        requiresAuth: true,
        mustCheckMenuPermissions: true,
        helpTopicKey: 'post-harvest-workflows-defining-task-types',
      },
    },
    {
      name: 'virtual-device-types',
      path: '/admin/virtual-device-types',
      component: VirtualDeviceTypes,
      meta: {
        requiresAuth: true,
        mustCheckMenuPermissions: true,
      },
    },
    {
      name: 'exception-types',
      path: '/admin/exception-types',
      component: ExceptionTypes,
      meta: {
        requiresAuth: true,
        mustCheckMenuPermissions: true,
        helpTopicKey: 'administration-exception-alerts',
      },
    },
    {
      name: 'exception-notified-users',
      path: '/admin/exception-notified-users',
      component: ExceptionNotifiedUsers,
      meta: {
        requiresAuth: true,
        mustCheckMenuPermissions: true,
        helpTopicKey: 'administration-exception-alerts',
      },
    },
    {
      name: 'user-exception-logs',
      path: '/admin/user-exception-logs',
      component: UserExceptionLogs,
      meta: {
        requiresAuth: true,
        // mustCheckMenuPermissions: true,
        helpTopicKey: 'administration-exception-alerts',
      },
    },
    {
      name: 'hardware-ticket-statuses',
      path: '/admin/ticket-statuses',
      component: HardwareTicketStatuses,
      meta: {
        requiresAuth: true,
        mustCheckMenuPermissions: true,
      },
    },
    {
      name: 'hardware-ticket-problem-types',
      path: '/admin/ticket-problemTypes',
      component: HardwareTicketProblemTypes,
      meta: {
        requiresAuth: true,
        mustCheckMenuPermissions: true,
      },
    },
    {
      name: 'inventory',
      path: '/admin/inventory',
      component: Inventory,
      meta: {
        requiresAuth: true,
        mustCheckMenuPermissions: true,
      },
    },
    {
      name: 'inventoryHistory',
      path: '/admin/inventory-history',
      component: InventoryHistory,
      meta: {
        requiresAuth: true,
        mustCheckMenuPermissions: true,
      },
    },
    {
      name: 'repeating-tasks',
      path: '/tasks/repeating',
      component: RepeatingTasks,
      meta: {
        requiresAuth: true,
        mustCheckMenuPermissions: true,
      },
    },
    {
      name: 'growphase-templates',
      path: '/growphase-templates',
      component: GrowphaseTemplates,
      meta: {
        requiresAuth: true,
        mustCheckMenuPermissions: true,
        helpTopicKey: 'cultivation-grow-plan-phase-templates-overview',
      },
    },
    {
      name: 'lifecyclefixes',
      path: '/lifecycleremediations',
      component: LifecycleFixes,
      meta: {
        requiresAuth: true,
        mustCheckMenuPermissions: true,
        helpTopicKey: 'cultivation-lifecycle-remediations-overview',
      },
    },
    {
      name: 'port-expander-error-logs',
      path: '/admin/portexpandererrorlog',
      component: PortExpanderErrorLogs,
      meta: {
        requiresAuth: true,
        mustCheckMenuPermissions: true,
      },
    },
    {
      name: 'zoneConfig',
      path: '/zoneconfig',
      component: ZoneConfig,
      meta: {
        requiresAuth: true,
        mustCheckMenuPermissions: true,
        helpTopicKey: 'dashboards-zone-control-overview',
      },
    },
    {
      name: 'device',
      path: '/device/:deviceId/:controllerId',
      component: RacklessDevice,
      meta: {
        requiresAuth: true,
        mustCheckMenuPermissions: true,
      },
      props: true,
    },
    {
      name: 'test-batch',
      path: '/test-batches',
      component: TestBatch,
      meta: {
        requiresAuth: true,
        mustCheckMenuPermissions: true,
        helpTopicKey: 'post-harvest-lab-tests',
      },
    },
    {
      name: 'test-types',
      path: '/test-types',
      component: TestTypes,
      meta: {
        requiresAuth: true,
        mustCheckMenuPermissions: true,
      },
    },
    {
      name: 'laboratories',
      path: '/laboratories',
      component: Laboratories,
      meta: {
        requiresAuth: true,
        mustCheckMenuPermissions: true,
      },
    },
    {
      name: 'facilityconsumables',
      path: '/facilityconsumables',
      component: FacilityConsumables,
      meta: {
        requiresAuth: true,
        mustCheckMenuPermissions: true,
        helpTopicKey: 'consumables-overview',
      },
    },
    {
      name: 'dry-weights',
      path: '/dry-weights',
      component: DryWeights,
      meta: {
        requiresAuth: true,
        mustCheckMenuPermissions: true,
        helpTopicKey: 'post-harvest-dry-weights',
      },
    },
    {
      name: 'post-harvest-batches',
      path: '/post-harvest/batches',
      component: PostHarvestBatches,
      meta: {
        requiresAuth: true,
        mustCheckMenuPermissions: true,
        helpTopicKey: 'post-harvest-workflows-reviewing-batches',
      },
    },
    {
      name: 'malfunctioningGrowUnits',
      path: '/malfunctioning-grow-units',
      component: MalfunctioningGrowUnits,
      meta: {
        requiresAuth: true,
        mustCheckMenuPermissions: true,
      },
    },
    {
      name: 'units-of-measure',
      path: '/units-of-measure',
      component: UnitsOfMeasure,
      meta: {
        requiresAuth: true,
        mustCheckMenuPermissions: true,
      },
    },
    {
      name: 'consumable-calculation-types',
      path: '/admin/consumable-calculation-types',
      component: ConsumableCalculationTypes,
      meta: {
        requiresAuth: true,
        mustCheckMenuPermissions: true,
      },
    },
    {
      name: 'ipm-application-reports',
      path: '/ipm-spray-history',
      component: IpmApplicationReports,
      meta: {
        requiresAuth: true,
        mustCheckMenuPermissions: true,
      },
    },
    {
      name: 'consumables-ledger',
      path: '/consumables/ledger',
      component: ConsumablesLedger,
      meta: {
        requiresAuth: true,
        mustCheckMenuPermissions: true,
        helpTopicKey: 'consumables-reviewing-consumables-ledger',
      },
    },
    {
      name: 'opex-calculator',
      path: '/opex',
      component: OpExCalculator,
      meta: {
        requiresAuth: true,
        mustCheckMenuPermissions: true,
        helpTopicKey: 'opex-calculator-overview',
      },
    },
    {
      name: 'service-levels',
      path: '/admin/serviceLevels',
      component: ServiceLevels,
      meta: {
        requiresAuth: true,
        mustCheckMenuPermissions: true,
      },
    },
    {
      name: 'service-level-agreements',
      path: '/admin/servicelevelAgreements',
      component: ServiceLevelAgreements,
      meta: {
        requiresAuth: true,
        mustCheckMenuPermissions: true,
      },
    },
    {
      name: 'nutrient-deficiency-diagnosis',
      path: '/admin/nutrientdeficiencydiagnosis',
      component: NutrientDeficiencyDiagnosis,
      meta: {
        requiresAuth: true,
        mustCheckMenuPermissions: true,
      },
    },

    {
      name: 'subtenant',
      path: '/dashboard/subtenant',
      component: SubtenantStatus,
      meta: {
        requiresAuth: true,
        mustCheckMenuPermissions: true,
        helpTopicKey: 'dashboards-overview',
      },
    },

    {
      name: 'plantContainerTypes',
      path: '/admin/plantcontainertypes',
      component: PlantContainerTypes,
      meta: {
        requiresAuth: true,
        mustCheckMenuPermissions: true,
      },
    },
    {
      name: 'release-notes',
      path: '/admin/releaseNotes',
      component: ReleaseNotes,
      meta: {
        requiresAuth: true,
        mustCheckMenuPermissions: true,
      },
    },
    {
      name: 'sops',
      path: '/admin/sops',
      component: SOPs,
      meta: {
        requiresAuth: true,
        mustCheckMenuPermissions: true,
      },
    },
    {
      name: 'stateCompliance',
      path: '/admin/facilities/statecompliance',
      component: StateCompliance,
      meta: {
        requiresAuth: true,
        mustCheckMenuPermissions: true,
        helpTopicKey: 'metrc-synchronizing-facility-licenses',
      },
    },
    {
      name: 'boardConfigWizard',
      path: '/admin/boardconfigurationwizard',
      component: BoardConfigurationWizard,
      meta: {
        requiresAuth: true,
        mustCheckMenuPermissions: true,
        helpTopicKey: 'system-add-device-overview',
      },
    },
    {
      name: 'provisionalControllers',
      path: '/admin/provisional-controllers',
      component: ProvisionalControllers,
      meta: {
        requiresAuth: true,
        mustCheckMenuPermissions: false, //TODO: Add permissions for this
      },
    },
    {
      name: 'controlBoard',
      path: '/admin/controlboard',
      component: ControlBoard,
      meta: {
        requiresAuth: true,
        mustCheckMenuPermissions: true,
      },
    },
    {
      name: 'clients',
      path: '/admin/clients',
      component: Clients,
      meta: {
        requiresAuth: true,
        mustCheckMenuPermissions: true,
      },
    },
    {
      name: 'growstages',
      path: '/admin/growstages',
      component: GrowStages,
      meta: {
        requiresAuth: true,
        mustCheckMenuPermissions: true,
      },
    },
    {
      name: 'redalerts',
      path: '/admin/redalerts',
      component: RedAlerts,
      meta: {
        requiresAuth: true,
        mustCheckMenuPermissions: true,
      },
    },
    {
      name: 'facility-alerts',
      path: '/facility/alerts',
      component: FacilityAlerts,
      meta: {
        requiresAuth: true,
        mustCheckMenuPermissions: true,
      },
    },
    {
      name: 'metrcLocations',
      path: '/admin/metrc/locations',
      component: MetrcLocations,
      meta: {
        requiresAuth: true,
        mustCheckMenuPermissions: true,
        helpTopicKey: 'metrc-facility-locations',
      },
    },
    {
      name: 'metrcItems',
      path: '/admin/metrc/items',
      component: MetrcItems,
      meta: {
        requiresAuth: true,
        mustCheckMenuPermissions: true,
        helpTopicKey: 'metrc-items',
      },
    },

    {
      name: 'metrcPackages',
      path: '/admin/metrc/packages',
      component: MetrcPackages,
      meta: {
        requiresAuth: true,
        mustCheckMenuPermissions: true,
      },
    },

    {
      name: 'metrcHarvests',
      path: '/admin/metrc/harvests',
      component: MetrcHarvests,
      meta: {
        requiresAuth: true,
        mustCheckMenuPermissions: true,
      },
    },

    {
      name: 'metrcPlants',
      path: '/admin/metrc/plants',
      component: MetrcPlants,
      meta: {
        requiresAuth: true,
        mustCheckMenuPermissions: true,
      },
    },

    {
      name: 'metrcOutbox',
      path: '/admin/metrc/outbox',
      component: MetrcOutbox,
      meta: {
        requiresAuth: true,
        mustCheckMenuPermissions: true,
      },
    },

    {
      name: 'metrcPlantBatches',
      path: '/admin/metrc/plantbatches',
      component: MetrcPlantBatches,
      meta: {
        requiresAuth: true,
        mustCheckMenuPermissions: true,
        helpTopicKey: 'metrc-plant-batches',
      },
    },

    {
      name: 'metrcCacheStatus',
      path: '/admin/metrc/cachestatus',
      component: MetrcCacheStatus,
      meta: {
        requiresAuth: true,
        mustCheckMenuPermissions: true,
        helpTopicKey: 'metrc-downloading-data-from-metrc',
      },
    },

    {
      name: 'metrcStrains',
      path: '/admin/metrc/strains',
      component: MetrcStrains,
      meta: {
        requiresAuth: true,
        mustCheckMenuPermissions: true,
        helpTopicKey: 'metrc-strain-management',
      },
    },

    {
      name: 'metrcLabTests',
      path: '/admin/metrc/labtests',
      component: MetrcLabTests,
      meta: {
        requiresAuth: true,
        mustCheckMenuPermissions: true,
      },
    },

    {
      name: 'metrcTestingLabs',
      path: '/admin/metrc/testinglabs',
      component: MetrcTestingLabs,
      meta: {
        requiresAuth: true,
        mustCheckMenuPermissions: true,
      },
    },

    {
      name: 'FSA',
      path: '/admin/fsa',
      component: Fsa,
      meta: {
        requiresAuth: true,
        mustCheckMenuPermissions: true,
      },
    },

    {
      name: 'PostHarvestCharts',
      path: '/postharvest/charts',
      component: PostHarvestCharts,
      meta: {
        requiresAuth: true,
        mustCheckMenuPermissions: true,
      },
    },

    {
      name: 'MetrcSales',
      path: '/admin/metrc/sales',
      component: MetrcSales,
      meta: {
        requiresAuth: true,
        mustCheckMenuPermissions: true,
      },
    },

    {
      name: 'MetrcTransfers',
      path: '/admin/metrc/transfers',
      component: MetrcTransfers,
      meta: {
        requiresAuth: true,
        mustCheckMenuPermissions: true,
      },
    },

    {
      name: 'EcuTestPlans',
      path: '/admin/ecutestplans',
      component: EcuTestPlans,
      meta: {
        requiresAuth: true,
        mustCheckMenuPermissions: true,
      },
    },

    {
      name: 'FacilityMaps',
      path: '/admin/facilitymaps',
      component: FacilityMaps,
      meta: {
        requiresAuth: true,
        mustCheckMenuPermissions: true,
      },
    },

    {
      name: 'FacilityMapsDisplay',
      path: '/dashboard/facilitymaps',
      component: FacilityMapsDisplay,
      meta: {
        requiresAuth: true,
        mustCheckMenuPermissions: true,
      },
    },

    {
      name: 'ProductInventory',
      path: '/postharvest/productinventory',
      component: ProductInventory,
      meta: {
        requiresAuth: true,
        mustCheckMenuPermissions: true,
      },
    },

    {
      name: 'PlantIntake',
      path: '/facility-intake/plants',
      component: PlantIntake,
      meta: {
        requiresAuth: true,
        mustCheckMenuPermissions: true,
      },
    },

    {
      name: 'InventoryIntake',
      path: '/facility-intake/inventory',
      component: InventoryIntake,
      meta: {
        requiresAuth: true,
        mustCheckMenuPermissions: true,
      },
    },

    {
      name: 'Diagnostics',
      path: '/systemadmin/diagnostics',
      component: Diagnostics,
      meta: {
        requiresAuth: true,
        mustCheckMenuPermissions: true,
      },
    },

    {
      name: 'Controllers',
      path: '/systemadmin/controllers',
      component: Controllers,
      meta: {
        requiresAuth: true,
        mustCheckMenuPermissions: true,
      },
    },

    {
      name: 'FacilityInfrastructure',
      path: '/systemadmin/facility-infrastructure',
      component: FacilityInfrastructure,
      meta: {
        requiresAuth: false,
        mustCheckMenuPermissions: false,
      },
    },

    {
      name: 'GoodNewsPresentation',
      path: '/presentation/goodnews',
      component: GoodNewsPresentation,
      meta: {
        requiresAuth: true,
        mustCheckMenuPermissions: true,
      },
    },
    /*
    {
      name: 'DeviceConfigTemplates',
      path: '/systemadmin/device-configuration-templates',
      component: DeviceConfigTemplates,
      meta: {
        requiresAuth: true,
        mustCheckMenuPermissions: true
      }
    },
    */
    {
      name: 'LightSpectrumDefinitions',
      path: '/systemadmin/light-spectrum-definitions',
      component: LightSpectrumDefinitions,
      meta: {
        requiresAuth: true,
        mustCheckMenuPermissions: true,
      },
    },

    {
      name: 'CameraTypes',
      path: '/systemadmin/cameratypes',
      component: CameraTypes,
      meta: {
        requiresAuth: true,
        mustCheckMenuPermissions: true,
      },
    },

    {
      name: 'ActiveUnitsReport',
      path: '/systemadmin/active-units-report',
      component: ActiveUnitsReport,
      meta: {
        requiresAuth: true,
        mustCheckMenuPermissions: true,
      },
    },

    {
      name: 'ProductionSuccessReport',
      path: '/systemadmin/production-success-report',
      component: ProductionSuccessReport,
      meta: {
        requiresAuth: true,
        mustCheckMenuPermissions: true,
      },
    },

    {
      name: 'HarvestHistoryReport',
      path: '/systemadmin/harvest-history-report',
      component: HarvestHistoryReport,
      meta: {
        requiresAuth: true,
        mustCheckMenuPermissions: true,
      },
    },
    {
      name: 'PackagesReport',
      path: '/systemadmin/packages-report',
      component: PackagesReport,
      meta: {
        requiresAuth: true,
        mustCheckMenuPermissions: true,
      },
    },
    {
      name: 'InvoiceReport',
      path: '/systemadmin/invoice-report',
      component: InvoiceReport,
      meta: {
        requiresAuth: true,
        mustCheckMenuPermissions: true,
      },
    },
    {
      name: 'DataArchiveTool',
      path: '/systemadmin/data-archive-tool',
      component: DataArchiveTool,
      meta: {
        requiresAuth: true,
        mustCheckMenuPermissions: true,
      },
    },

    {
      name: 'FacilityEquipment',
      path: '/extraction/facility-equipment',
      component: FacilityEquipment,
      meta: {
        requiresAuth: true,
        mustCheckMenuPermissions: true,
      },
    },

    {
      name: 'ExtractionEquipment',
      path: '/extraction/equipment',
      component: ExtractionEquipment,
      meta: {
        requiresAuth: true,
        mustCheckMenuPermissions: true,
      },
    },

    {
      name: 'ExtractionRecipes',
      path: '/extraction/recipes',
      component: ExtractionRecipes,
      meta: {
        requiresAuth: true,
        mustCheckMenuPermissions: true,
      },
    },

    {
      name: 'ExtractionWorkflows',
      path: '/extraction/workflows',
      component: ExtractionWorkflows,
      meta: {
        requiresAuth: true,
        mustCheckMenuPermissions: true,
      },
    },

    {
      name: 'ExtractionEquipmentDashboard',
      path: '/extraction/equipmentdashboard',
      component: ExtractionEquipmentDashboard,
      meta: {
        requiresAuth: true,
        mustCheckMenuPermissions: true,
      },
    },

    {
      name: 'SurveillanceCameras',
      path: '/surveillancecameras',
      component: SurveillanceCameras,
      meta: {
        requiresAuth: true,
        mustCheckMenuPermissions: true,
      },
    },

    {
      name: 'Harvests',
      path: '/postharvest/harvests',
      component: Harvests,
      meta: {
        requiresAuth: true,
        mustCheckMenuPermissions: true,
      },
    },

    {
      name: 'ExtractionVdt',
      path: '/extraction/devicetypes',
      component: ExtractionVdt,
      meta: {
        requiresAuth: true,
        mustCheckMenuPermissions: true,
      },
    },

    {
      name: 'WashingtonStateCompliance',
      path: '/compliance/washington',
      component: WashingtonStateCompliance,
      meta: {
        requiresAuth: true,
        mustCheckMenuPermissions: true,
      },
    },

    {
      name: 'WashingtonStateComplianceExports',
      path: '/compliance/washington/exports/:id',
      component: WashingtonStateComplianceExports,
      props: true,
      meta: {
        requiresAuth: true,
        mustCheckMenuPermissions: false,
      },
    },

    {
      name: 'PLCs',
      path: '/systemadmin/plcs',
      component: PLCs,
      props: true,
      meta: {
        requiresAuth: true,
        mustCheckMenuPermissions: true,
      },
    },

    {
      name: 'software-ticketing-system-kan-ban-view',
      path: '/software-ticketing-system/kan-ban',
      component: SoftwareKanBanView,
      meta: {
        requiresAuth: true,
        mustCheckMenuPermissions: true,
      },
    },
    {
      name: 'hardware-ticketing-system-kan-ban-view',
      path: '/hardware-ticketing-system/kan-ban',
      component: HardwareKanBanView,
      meta: {
        requiresAuth: true,
        mustCheckMenuPermissions: true,
      },
    },
    {
      name: 'activity-logs',
      path: '/admin/activity-logs',
      component: ActivityLogs,
      meta: {
        requiresAuth: true,
        mustCheckMenuPermissions: true,
      },
    },
    {
      name: 'sensors',
      path: '/sensors',
      component: Sensors,
      props: true,
      meta: {
        requiresAuth: true,
        mustCheckMenuPermissions: false,
      },
    },
    {
      path: '*',
      redirect: '/notfound',
    },
    {
      path: '/',
      redirect: '/dashboard',
    },
  ],
});

router.beforeEach(requiresAuth);
router.beforeEach(checkMenuPermissions);
router.beforeEach(setRouteHelpTopic);

export default router;
